module.exports = __webpack_public_path__ + "img/1503149721.70f3375e.jpg";